// Types
import {CurriedFn2} from 'isee/types/curried';

type Cancel = () => void;
type Callback = (...args: any[]) => void;
type DebouncedCallback = (...args: any[]) => Cancel;

export const debounce: CurriedFn2<number, Callback, DebouncedCallback> = (
  ms: number,
  callback?: Callback
) => {
  if (!callback) return debounce.bind(null, ms);

  let cancel = () => {};
  const debounced = (...args: any[]) => {
    cancel();
    const timeout = setTimeout(() => callback(...args), ms);
    cancel = () => clearTimeout(timeout);
    return cancel;
  };

  return debounced;
};



// WEBPACK FOOTER //
// ./src/utils/debounce/debounce.ts